import styled from 'styled-components';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
// Style調整
const HeadingTitle = styled.h2`
    background-color: hotpink;
    color: #fff;
    font-weight: bold;
    letter-spacing: 20px;
    padding: 50px 0px 50px;
    width: 90%;
    margin: 0px auto;
    margin-top: 120px;
    border-radius: 10px;
`

const TextTitle = styled.h4`
    font-weight: bold;
    color: rgb(10, 66, 117);
`;

const MarginWid = styled.div`
    width:90%;
    margin: auto;
`;

// 合格体験記
const TrialRecord = () => {
    return (
        <>
            <div className="text-center">
                <HeadingTitle>合格体験記</HeadingTitle>
            </div>
            <ScrollToTopOnMount />
            {/* 篠原さん */}
            <MarginWid className="card-body">
                <TextTitle>西大和学園、神戸女学院、土佐中学校合格体験記</TextTitle>
                <p class="card-text lh-1">私が志望校に合格できた理由には、自分の努力のほかに、家族の積極的な協力があったことも大きいと思います。</p>
                <p class="card-text lh-sm">　両親は私の塾の送り迎えを毎日してくれて、私の体調などを常に心配してくれました。また、受験の日が近づいてもいつもと変わらない態度で応援してくれたので、あまり緊張せずに受験をすることができました。
                    　先生方にもとてもお世話になりました。苦手な科目の勉強でも根気強く教えてくれ、苦手を克服できたし、過去問の丁寧な解説のおかげでより理解を深めることができたので、とても感謝しています。</p>
                <p class="card-text lh-base">受験勉強中、私が生活上で気をつけたことは、「眠くなったら寝る」ということです。眠い時にだらだらと勉強していると効率が下がり、健康にも悪いからです。また、気分転換をしたい時は縄跳びをしました。ときどき外の空気を吸うと、頭がすっきりします。みなさんも、自分なりの勉強の進め方を見つけると良いと思います。
                    　入試本番、思わぬハプニングが起こったり、得点できなかったりすることがあります。私の場合は、答えを書く場所が一つずれていて全て書き直さなくてはならなくなりました。そんな時は少なからず動揺してしまうので、前もって「こういうハプニングが起こることもある」ということを知っておいてほしいです。</p>
                <p class="card-text lh-lg">　新たに受験生となるみなさんへ、最も大切なのは自分の努力です。あきらめずに勉強を続けて合格を勝ち取ってほしいと思います。がんばってください!!</p>
                <p className="card-text text-end">(四谷大塚ＹＴ教室　篠原 美咲)</p>
            </MarginWid>

            {/* 中本さん */}
            <MarginWid className="card-body">
                    <TextTitle>鷗友学園、浦和明の星女子中学校合格体験記受験までの日々</TextTitle>
                            <p class="card-text lh-1"> 私は四年生の十二月からと少し遅めに入塾しました。初めは成績が全然志望校に届きませんでしたが、この春志望校に合格することができました。</p>
                            <p class="card-text lh-sm">入塾した直後はあまり授業についていけませんでした。しかし家で特別な勉強をすることなくいつの間にか授業がよく分かるようになりました。それは先生の丁寧な説明のおかげだと思います。塾に通うとやはり睡眠時間の確保には苦労しました。六年生くらいになるまでは眠くても宿題をやって授業中にものすごい睡魔におそわれることがありました。しかし後からそれに後悔したので六年生くらいからはとにかく授業を優先し、宿題は隙間時間にやってそれでも終わらなければあきらめるようにしました。とにかく睡眠時間はとるべきだと思います。</p>
                            <p class="card-text lh-base">私は、算数がとても苦手でした。五年生くらいまでは復習をあまりやらなかったことを後悔しています。六年生くらいからは自分が間違えた問題を父に説明してもらい、自分の理解を深めるようにしました。そのおかげで少しずつ偏差値も上がるようになりました。</p>
                            <p class="card-text lh-base">入試の直前は、とにかく本番をイメージして緊張しておき、当日に思わぬ緊張がないようにしました。そして熱を出したりしないように健康管理には家族みんなで気を配りました。</p>
                            <p class="card-text lh-base">当日は深呼吸によってとてもよい状態で問題に取り組めたと思います。たかが深呼吸と思うかもしれませんが、本当に適度な緊張感になるのでおすすめします。
            　                                         皆さんにはこの合格体験記を参考にして合格を勝ち取ってほしいと思います。
            　                                         最後に、私の受験を支えて下さった先生、一緒に勉強してくれた友達、本当にありがとうございました。</p>
                            <p className="card-text text-end">(四谷大塚ＹＴ教室　中本 真緒)</p>
            </MarginWid>
            {/* 中本さん終了 */}

            {/* 鍵山さん */}
            <MarginWid className="card-body">
                <TextTitle>岡山、同志社、土佐中学校合格体験記</TextTitle>
                <p class="card-text lh-1"> 私も土佐塾の体験を書くことができてすごくうれしいです。ＹＴの先生には、感謝しかありません。とにかく先生方が本気で向きあってくれる塾です。私は五年生まで土佐中を受験することすらできないレベルでした。私は大人数の中で質問をするのが苦手なのでＹＴの少人数制が自分には非常にあっていました。授業中もどんどんあてられるのでボーッとするひまもなく集中して授業に取り組むことができました</p>
                <p class="card-text lh-sm">ＹＴに入ってよかったことは、難しい問題をわかるまで教えてくれる所です。休みの日も補習をしてくれて、とにかく問題を解くことによって得意教科にしていただきました。また、他の塾よりも個別指導をしてくれるので質問をしやすいです。</p>
                <p class="card-text lh-base">入試の直前は、とにかく本番をイメージして緊張しておき、当日に思わぬ緊張がないようにしました。そして熱を出したりしないように健康管理には家族みんなで気を配りました。</p>
                <p class="card-text lh-base">ＹＴに入って大変だったことは、とにかく授業が進むのが早いので、家でしっかりと授業の復習をしなければいけません。他にも毎日たくさんの宿題が出されました。でも、そのおかげで五年生が終わるころにはずいぶんできるようになっていました。また、とにかく勉強をする時間がとても長いです。だから、五年生までに六年生の内容がすべて終わっているので、必死で先生についていくと、気がついたら他の子よりも早く過去問に取り掛かることもでき、十年分以上のすべての教科の過去問を解くことができました。そして土佐、県外受験ができるところまで成績が上がっていました。前田先生が岡山中学校、同志社中学校、土佐中学校など生徒一人一人に親身になって受験校を選んでくれて、こんな私でも三勝することができました。努力はきっと報われるということを教えてもらいました</p>
                <p className="card-text text-end">(四谷大塚ＹＴ教室　鍵山 果歩)</p>
            </MarginWid>
        </>
    );
}

export default TrialRecord;